/**
 * User-facing copy for Designer Agent (Create Design blade + standalone page).
 * Contrasts with AI Campaign (smart-campaign production path).
 */

export const DESIGNER_AGENT_TAB_LABEL = 'Designer Agent';

export const DESIGNER_AGENT_DIALOG_TITLE = 'Designer Agent';

export const DESIGNER_AGENT_DIALOG_SUBTITLE =
  'Prompt → draft with senior design craft and Pexels stock. Uses Template Library knowledge (LanceDB). No actor video in this path.';

/** Short contrast shown on the AI Campaign blade. */
export const AI_CAMPAIGN_DIALOG_SUBTITLE =
  'Production path: brief + your uploads (stock may fill gaps). Can include voiceover, CTA, and personalized actor video when you ask. Different from Designer Agent.';

export const DESIGNER_AGENT_COMPARISON_CALLOUT =
  'Different from AI Campaign: AI Campaign is the live smart-campaign path (uploads, brand RAG, optional actor video). Designer Agent is an additive next path — scenes + DesignSpec + Pexels only, via /ai/designer-create-draft.';

export const DESIGNER_AGENT_PAGE_INTRO =
  'Describe the video. Designer Agent plans scenes, applies senior design craft, pulls Pexels stock, and opens a draft. This does not replace production Create Design (AI Campaign).';
